import React from "react";
import { Button, Typography, Box, Grid } from "@mui/material";
import "./password-reset-success.css"; // Import the CSS file
import { useNavigate } from "react-router-dom";

const PasswordResetSuccess = () => {
  const navigate = useNavigate();

  return (
    <Grid container className='success-container'>
      <Grid item xs={12} sm={8} md={4}>
        <Box className='success-form' p={4}>
          <img src='/images/sucess.png' alt='' className='lock' />
          <Box alignItems='center' className='input-group'>
            <Typography variant='h5' align='center' gutterBottom>
              Password reset
            </Typography>

            <Typography variant='body1' className='subtitle'>
              Your password has been successfully reset. You can now use your new password to log in.
            </Typography>
          </Box>
          <Grid item xs={12} className='success-button'>
            <Button fullWidth variant='contained' type='submit' onClick={() => navigate("/login")}>
              Continue
            </Button>
          </Grid>
        </Box>
      </Grid>
    </Grid>
  );
};

export default PasswordResetSuccess;
